export default {
  语言: '语言',
  报告内容模板: '报告内容模板',
};
